import React, {useContext, useState} from 'react'
import { getTransactions, getTransactionsById } from '../api/transactions';
import { AuthContext } from '../context/AuthContext';

export const useTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [transaction, setTransaction] = useState([]);
  const [totalPages, setTotalPages] = useState(1)
  const {setLoading,checkToken } = useContext(AuthContext);

  const getTransaction = async (currencyId, page,loading=true) => {
    checkToken()
    try {
        setLoading(loading);
        const {data} = await getTransactions(currencyId, page);
        setTransactions([...transactions, ...data.data.page])
        setTotalPages(data.data.totalPages)
        setLoading(false);
        return [true,data.data];
    } catch(error){
        setLoading(false);
        console.log(error)
        setTransactions([]);
        return [false];
    }
  }

  const getTransactionById = async (transactionId) => {
    checkToken()
    try {
      setLoading(true);
      const {data} = await getTransactionsById(transactionId);
      setTransaction(data.data);
      setLoading(false);
      return true;
    } catch(error){
      setLoading(false);
      console.log(error)
    }
  }

  const formatDate = (date) => {
    const dateFormatted = new Date(date);
    const day = dateFormatted.getDate();
    const month = dateFormatted.getMonth() + 1;
    const year = dateFormatted.getFullYear();
    const hour = dateFormatted.getHours();
    const minutes = dateFormatted.getMinutes();
    return `${day}/${month}/${year} a las ${hour}:${minutes}`;
}


  return {
      transactions,
      getTransaction,
      getTransactionById,
      transaction,
      formatDate,
      totalPages,
      setTransactions
  }
}
